'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = route;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isReactComponent = require('../core/isReactComponent');

var _isReactComponent2 = _interopRequireDefault(_isReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeRouteOptions(routeConfig) {
  if (routeConfig.routes) {
    routeConfig.routes.forEach(function (child) {
      if (child.component && child.component.routeOptions) {
        mergeRouteOptions(Object.assign(child, child.component.routeOptions));
      }
    });
  }
}

// # 路由配置生成器
function route(path, RouteComponent) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var routeConfig = Object.assign({
    resolvePath: path,
    path: path || option.name,
    name: option.name,
    navKey: option.navKey,
    component: RouteComponent,
    fpath: option.fpath,
    parent: option.parent
  }, RouteComponent.routeOptions);
  // 把子路由组件的routeOptions也合并进来
  mergeRouteOptions(routeConfig);

  if (option.callback && option.callback(routeConfig, option.strict) === false) {
    return null;
  }

  var indexRoute = routeConfig.indexRoute;
  if (indexRoute) {
    if ((0, _isReactComponent2.default)(indexRoute)) {
      routeConfig.indexRoute = Object.assign({
        component: indexRoute
      }, indexRoute.routeOptions);
    } else if (typeof indexRoute === 'function') {
      routeConfig.indexRoute = Object.assign({
        getComponent: indexRoute
      }, indexRoute.routeOptions);
    } else {
      indexRoute.component = option.fromLazy(indexRoute.component);
      var routeOptions = indexRoute.component ? indexRoute.component.routeOptions : indexRoute.getComponent.routeOptions;
      routeConfig.indexRoute = Object.assign(indexRoute, routeOptions);
    }
  }

  // 重新修正component
  if (typeof routeConfig.component.then === 'function') {
    var promise = routeConfig.component;
    delete routeConfig.component;
    routeConfig.getComponent = function (nextState, callback) {
      promise.then(function (component) {
        callback(null, component);
      }, callback);
    };
  } else if (_react2.default.isValidElement(routeConfig.component)) {
    var element = routeConfig.component;
    routeConfig.component = function () {
      return element;
    };
    // function component, 必须存在props作为第一个参数
  } else if (!(0, _isReactComponent2.default)(routeConfig.component)) {
    routeConfig.getComponent = routeConfig.component;
    delete routeConfig.component;
  }

  return routeConfig;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/route.js
// module id = 178
// module chunks = 0